import React from 'react'
import { Typography, Grid, Box } from '@material-ui/core'
import { CancelPresentation } from '@material-ui/icons'
import numeral from 'numeral'

// Components
import TextField from 'StandardComponents/CustomTextfield/CustomTextField'
import AutoComplete from 'StandardComponents/AutoCompleteTextfield/AutoCompleteTextfield'
import TextFieldCurrency from 'StandardComponents/TextFieldCurrency/TextFieldCurrency'
import Select from 'StandardComponents/CustomedSelect/CustomedSelect'

import classes from './CreateLiquidation2ndPage.module.scss'

export default function CreateLiquidation2stPage(props) {
  const {
    onClickAutoComplete,
    onChangeAutoComplete,
    handleOnchangeProjectClass,
    suggestionGLCategory,
    suggestionGLAccounts,
    suggestionsRequestingDepartment,
    value,
    setValue,
    params,
    setSuggestionGLCategory,
    suggestionadvanceProjectClass,
    setSuggestionGLAccounts,
    setSuggestionAdvanceProjectClass,
    setSuggestionsRequestingDepartment,
    handleOnCloseProjectClass,
    handleOnComputation,
    setIndexer,
    projectClass
  } = props
  const [indexGetter, setIndexGetter] = React.useState(0)
  const [indexGetterFile, setIndexGetterFile] = React.useState(0)
  React.useEffect(() => {
    if (value.department) {
      let projectClass = [...value.projectClass]
      projectClass[parseInt(indexGetter)]['classDepartment'] = value.department
      setValue({ ...value, projectClass: projectClass })
    }
  }, [indexGetter])

  return (
    <React.Fragment>
      {projectClass.map((items, index) => (
        <div className={classes.root}>
          <Box
            className={classes.paper}
            key={index}
          >
            <div className={classes.header}>
              <Typography className={classes.page}>
                {index + 1}
              </Typography>
              {index > 0 ? (
                <CancelPresentation className={classes.close} onClick={() => handleOnCloseProjectClass(index)} />
              ) : ('')}
            </div>
            <div className={classes.body}>
              <Grid constainer spacing={3} justify="center">
                <Grid item xs={12}>
                  <Select
                    label='GL Category'
                    constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
                    value={items.glCategory}
                    name={'glCategory'}
                    suggestions={suggestionGLCategory}
                    onClick={() => {
                      setIndexer(index)
                      setIndexGetter(index)
                    }}
                    onChange={(event, isClick) => {
                      onChangeAutoComplete({
                        event: event.target.value,
                        isSuggestionClick: isClick,
                        name: 'glCategory',
                        index: index,
                        handleOnComputation: handleOnComputation,
                        isProjectClass: true,
                        value: value,
                        params: params,
                        setSuggestion: setSuggestionGLCategory,
                        suggestion: suggestionGLCategory,
                        setValue: setValue
                      })
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoComplete
                    label='Account Code/Account Name'
                    constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
                    value={items.glAccount}
                    onClick={() => {
                      onClickAutoComplete({
                        name: 'glAccount',
                        value: value,
                        index: index,
                        isProjectClass: true,
                        setSuggestions: setSuggestionGLAccounts,
                        params: params
                      })
                      setIndexer(index)
                      setIndexGetter(index)
                    }}
                    suggestions={suggestionGLAccounts}
                    onChange={(event, isClick) => {
                      onChangeAutoComplete({
                        event: event,
                        isSuggestionClick: isClick,
                        name: 'glAccount',
                        index: index,
                        handleOnComputation: handleOnComputation,
                        value: value,
                        isProjectClass: true,
                        params: params,
                        setSuggestion: setSuggestionGLAccounts,
                        suggestion: suggestionGLAccounts,
                        setValue: setValue
                      })
                    }}
                  />
                </Grid>
                {items.glCategory === 'Advances' ? (
                  <Grid item xs={12}>
                    <AutoComplete
                      label='Project Class'
                      constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
                      value={items.projectClass}
                      onClick={() => {
                        onClickAutoComplete({
                          name: 'projectClass',
                          value: value,
                          isProjectClass: true,
                          index: index,
                          setSuggestions: setSuggestionAdvanceProjectClass,
                          params: params
                        })
                        setIndexer(index)
                        setIndexGetter(index)
                      }}
                      suggestions={suggestionadvanceProjectClass}
                      onChange={(event, isClick) => {
                        onChangeAutoComplete({
                          event: event,
                          isSuggestionClick: isClick,
                          name: 'projectClass',
                          isProjectClass: true,
                          value: value,
                          handleOnComputation: handleOnComputation,
                          index: index,
                          params: params,
                          setSuggestion: setSuggestionAdvanceProjectClass,
                          suggestion: suggestionadvanceProjectClass,
                          setValue: setValue
                        })
                      }}
                    />
                  </Grid>
                ) : ('')}
                <Grid item xs={12}>
                  <AutoComplete
                    label='Requesting Department'
                    constainerStyle={{ width: '100%', height: '10%', overflow: 'auto' }}
                    value={items.classDepartment ? items.classDepartment : value.department}
                    readOnly
                    onClick={() => {
                      onClickAutoComplete({
                        name: 'department',
                        value: value,
                        index: index,
                        setSuggestions: setSuggestionsRequestingDepartment,
                        params: params
                      })
                      setIndexer(index)
                      setIndexGetter(index)
                    }}
                    suggestions={suggestionsRequestingDepartment}
                    onChange={(event, isClick) => {
                      onChangeAutoComplete({
                        event: event,
                        isSuggestionClick: isClick,
                        name: 'classDepartment',
                        isProjectClass: true,
                        value: value,
                        index: index,
                        handleOnComputation: handleOnComputation,
                        params: params,
                        setSuggestion: setSuggestionsRequestingDepartment,
                        suggestion: suggestionsRequestingDepartment,
                        setValue: setValue
                      })
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    constainerStyle={{ width: '100%' }}
                    value={items.description1}
                    placeholder={'Enter description1...'}
                    onClick={() => {
                      setIndexGetter(index)
                      setIndexer(index)
                    }}
                    name='description1'
                    onChange={value => handleOnchangeProjectClass(value, 'description1', index)}
                    label='Description 1'
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    constainerStyle={{ width: '100%' }}
                    value={items.description2}
                    placeholder={'Enter description2...'}
                    name='description2'
                    onClick={() => {
                      setIndexGetter(index)
                      setIndexer(index)
                    }}
                    onChange={value => handleOnchangeProjectClass(value, 'description2', index)}
                    label='Description 2'
                  />
                </Grid>
                <Grid item xs={6} style={{ marginBottom: '20px' }}>
                  <TextFieldCurrency
                    label='Gross Price'
                    onClick={() => {
                      setIndexGetter(index)
                      setIndexer(index)
                    }}
                    value={items.grossPricePerItem}
                    onChange={value => handleOnchangeProjectClass(value, 'grossPricePerItem', index)}
                  />
                </Grid>
                <Grid item container xs={12}>
                  <Box className={classes.total}>
                    <Grid item container xs={8} spacing={1} direction={'row'}>
                      <Grid item xs={5}>
                        <Typography className={classes.fonts}>Sub Total Gross Price:</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={classes.value}>₱ {numeral(items.subTotalGrossPrice).format('0,0.00')}</Typography>
                      </Grid>
                    </Grid>
                    <Grid item container xs={8} spacing={1} direction={'row'}>
                      <Grid item xs={5}>
                        <Typography className={classes.fonts}>Sub Total Net Price:</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={classes.value}>₱ {numeral(items.subTotalNetPrice).format('0,0.00')}</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Box>
        </div>
      ))
      }
      <Box className={classes['total-container']}>
        <Grid container spacing={1} className={classes.body}>
          <Grid item container xs={8} spacing={1} direction={'row'}>
            <Grid item xs={5}>
              <Typography className={classes.fonts}>Requesting Gross Price:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.value}>₱ {numeral(value.requestingGrossPrice).format('0,0.00')}</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={8} spacing={1} direction={'row'}>
            <Grid item xs={5}>
              <Typography className={classes.fonts}>Requesting Amount:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.value}>₱ {numeral(value.requestingAmount).format('0,0.00')}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  )
}
